// extracted by mini-css-extract-plugin
export default {"mainContainer":"Main_mainContainer__2n9-i","mainCurtain":"Main_mainCurtain__Sycva"};